import { http } from './request';
import { PROJECT_CONFIG_URLS } from './urls';

export interface ProjectConfigPayload {
  appName: string;
}

export function getProjectConfig() {
  return http.get<ProjectConfigPayload>(PROJECT_CONFIG_URLS.publicConfig);
}
